<template>
    <div class="mt-4 mb-5">
        <div class="" v-if="loading">
            <!-- Show the loader when async operation is going on -->
            <div class="loader"></div>
        </div>
        <div class="row" v-if="!loading">
            <div class="col-12">
                <div class="mb-2">
                    <span class="mr-3 align-middle col-mb heading-text">Plugins</span>
                    <span class="badge badge-success" v-if="envType === 'live'">LIVE</span>
                    <span class="badge bg-violate" v-else>Staging</span>
                </div>
            </div>
            <div class="col-sm-12" >
                <div class="table-responsive">
                    <table class="table table-striped" style="width: 100%;">
                        <thead class="text-primary">
                        <tr>
                            <th class="text-center">Plugin</th>
                            <th class="text-center">Status</th>
                            <th class="text-center">Version</th>
                            <th class="text-center">Update</th>
                            <th class="text-center">Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(plugin, index) in filteredPlugins" :key="index">
                                <td class="text-center ">{{plugin.title}}</td>
                                <td class="text-center">
                                    <span :class="(plugin.status === 'inactive') ? 'badge badge-danger' : 'badge badge-success' ">{{plugin.status}}</span>
                                </td>
                                <td class="text-center">
                                    <span class="mr-1">{{plugin.version}}</span>
                                </td>
                                <td class="text-center">
                                    <span class="btn btn-primary btn-sm" v-if="plugin.update_version" v-on:click="updatePlugin(plugin)">
                                        {{plugin.update_version}} <i class="fa fa-refresh"></i>
                                    </span>
                                    <span class=" btn btn-default btn-sm mr-1" disabled v-else>Not Available</span>
                                </td>
                                <td class="text-center">
                                    <select class="d-inline-block form-control-sm"  v-model="plugin.selected_action" v-on:change="pluginAction(plugin)">
                                        <option disabled :value="undefined">Choose One</option>
                                        <option  value="deactivate">{{(plugin.status==='active')?'Deactivate':'Activate'}}</option>
                                        <option  value="uninstall">Uninstall</option>
                                    </select>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-sm-12" v-if="!loading && !filteredPlugins.length>0">
                <span class="text-primary">No Plugins exists for this domain!</span>
            </div>
        </div>

    </div>
</template>

<script>
    import swal from 'sweetalert2';
    export default {
        name: "Plugins",
        props: {
            account: {
                type: Object,
                required: true
            },
            envType: {
                type: String,
                required: true
            }
        },
        data(){
            return{
                loading:false,
                selectedMainDomain:'',
                plugins:[],
            }
        },
        computed:{
            filteredPlugins(){
                return this.plugins.filter(plugin=>{
                    return  !(plugin.status === 'dropin' || plugin.status === 'must-use');
                });
            },
        },
        created(){
            if(this.envType === 'live'){
                this.selectedMainDomain = this.account.domain;
            }else{
                this.selectedMainDomain = this.account.staging.domain;
            }
            this.getAllPlugins();
        },
        watch: {
            envType(val) {
                if(val === 'live'){
                    this.selectedMainDomain = this.account.domain;
                }else{
                    this.selectedMainDomain = this.account.staging.domain;
                }
                this.getAllPlugins();
            },
            account(){
                if(this.envType === 'live'){
                    this.selectedMainDomain = this.account.domain;
                }else{
                    this.selectedMainDomain = this.account.staging.domain;
                }
                this.getAllPlugins();
            }
        },
        methods:{
            async getAllPlugins(){
                if(this.selectedMainDomain){
                    this.loading = true;
                    const response = await this.$http.post('plugins',{
                        grant_type: "token",
                        ip: this.account.ftp.host,
                        domain:this.selectedMainDomain,
                    });
                    console.log(response.data.adminUsers);
                    this.plugins = response.data.adminUsers;
                    this.loading = false;
                }else{
                    this.plugins = [];
                }
            },
            pluginAction(plugin){
                if(plugin.selected_action==='uninstall'){
                    this.$http.post('plugins/uninstall',{
                        grant_type: "token",
                        ip: this.account.ftp.host,
                        domain:this.selectedMainDomain,
                        plugin:plugin.name,
                    }).then(async()=>{
                        plugin.selected_action = undefined;
                        this.getAllPlugins();
                        swal('Success!', 'Plugin has been Uninstalled!', 'success');
                    }).catch((e)=>{
                        console.log(e.response.data.msg);
                        plugin.selected_action = undefined;
                        swal('Error!', e.response.data.msg, 'error');
                    });
                }else if(plugin.selected_action==='deactivate'){
                    this.$http.post('plugins/toggle',{
                        grant_type: "token",
                        ip: this.account.ftp.host,
                        domain:this.selectedMainDomain,
                        plugin:plugin.name,
                    }).then(()=>{
                        this.getAllPlugins();
                        plugin.selected_action = undefined;
                        swal('Success!', 'Plugin has been toggled!', 'success');
                    }).catch((e)=>{
                        console.log(e.response.data.msg);
                        plugin.selected_action = undefined;
                        swal('Error!', e.response.data.msg, 'error');
                    });
                }
            },
            async updatePlugin(plugin){
                this.$http.post('plugins/update',{
                    grant_type: "token",
                    ip: this.account.ftp.host,
                    domain:this.selectedMainDomain,
                    plugin:plugin.name,
                }).then(()=>{
                    this.getAllPlugins();
                    swal('Success!', 'Plugin has been Updated!', 'success');
                }).catch((e)=>{
                    console.error(e.response.data.msg);
                    swal('Success!', 'Plugin has been Updated!', 'success');
                    this.getAllPlugins();
                    // swal('Error!', e.response.data.msg, 'error');
                });
            }
        }
    }
</script>

<style scoped>

</style>
